export default __webpack_public_path__ + "static/media/013-Ram Memory.f4c290e3.svg";